import React, { useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Reproducibility_Report_Filter from "./reproducibility_report_filter/Reproducibility_Report_Filter";
import Reproducibility_Report_Table from "./reproducibility_report_table/Reproducibility_Report_Table";



const Reproducibility_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Reproducibility_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Reproducibility_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Reproducibility Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Reproducibility_Report;
